module.exports = __webpack_public_path__ + "img/file-minus.5a7f514d.svg";